import { useEffect, useState } from 'react';
import { 
  Button, Link, Grid, Typography, Container, ListItem, ListItemText,
  IconButton, Alert
} from '@mui/material';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import PinInput from 'react-pin-input';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import { checkCode, addUser } from '../../actions/users';
import { isEmpty } from '../common/helpers';

const Step3 = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [verificacion, setVeri] = useState('');
  const [disable, setDisable] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setDisable(verificacion.length!==4);
  }, [verificacion]);

  if(!state || state === undefined) {
    return <Navigate exact to="/signup" />
  }

  const guardar = async e => {
    e.preventDefault();
    setDisable(true);

    const dbInfo = {
      name: state.infoUser.username,
      email: state.infoUser.email,
      avatar: '',
      tel: state.infoUser.tel,
      password: state.infoUser.pass
    };

    if(state.emailTel === "celular"){
      const info = {
        phonenumber: state.to,
        code: verificacion,
      }
      setDisable(true);
      const res = await checkCode(info, navigate, true);
      if(res.valid){
        await addUser(dbInfo, navigate);
      } else {
        setDisable(false);
        setError("Código incorrecto");
      }
    } else {
      if(state.infoUser.codigo.toString() === verificacion){
        await addUser(dbInfo, navigate);
      } else {
        setError("Código incorrecto");
        setDisable(false);
      }
    }
  }

  return (
    <Container component="main" maxWidth="lg">
      <Grid className="container-steps" container spacing={{ lg: 3}}>
        <Grid className="steps" item size={{xs: 12, lg: 4}}>
          <img src="/logo-os-24.svg" alt="OneService" />
          <Typography variant="h5" component="h5">Código</Typography>
          <Grid className="list-steps" item size={12}>
            <ListItem className="step-active-second" alignItems="flex-start">
              <ListItemText primary="Selección de verificación" />
            </ListItem>
            <ListItem className="step-active" alignItems="flex-start">
              <ListItemText primary="Código" />
            </ListItem>
          </Grid>
        </Grid>
        <Grid className="form-steps" item size={{xs: 12, lg: 8}}>
          <form noValidate onSubmit={guardar}>
            <Grid item size={12}>
              <IconButton
                className="btn-icon"
                aria-label="back"
                onClick={() => navigate(-1)}
                sx={{width: 55, height: 55}}
              >
                <ChevronLeftIcon sx={{fontSize: 38}} />
              </IconButton>
            </Grid>
            <Grid container sx={{my:2}} spacing={{sx: 1}}>
              <Grid className="step1" item container direction="column">
                <Typography variant="h3" component="h3">Código</Typography>
                <Typography component="p">Introduce el código recibido.</Typography>
              </Grid>
              <Grid item size={12}>
                <PinInput
                  length={4}
                  onChange={(value) => setVeri(value)}
                />
              </Grid>
              <Grid item size={8} sx={{mt: 3}}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  disabled={disable}
                >
                  Verificar
                </Button>
              </Grid>
            </Grid>
            {
              !isEmpty(error) && (
                <Alert className="mss-alert" severity="error">
                  <Typography component="p" color="error">{error}</Typography>
                </Alert>
              )
            }

            <Grid container>
              <Grid item size={12}>
                <Typography className="link" component="p">
                  ¿No puedes acceder?
                  <Link href="#" underline='none'> - ayuda en línea</Link>
                </Typography>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
}


export default Step3;